import React, { useState, useRef, useEffect } from 'react';
import s from './s.module.less';
import { ProspectNotesItem } from 'types/common';
import dayjs from 'dayjs';

interface NoteProps {
    note: ProspectNotesItem;
}

const Note: React.FC<NoteProps> = ({ note }) => {
    const [expanded, setExpanded] = useState(false);
    const [isOverflow, setIsOverflow] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);
    const hiddenRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (hiddenRef.current && contentRef.current) {
            setIsOverflow(hiddenRef.current.offsetWidth > contentRef.current.offsetWidth);
        }
    }, [note]);

    const timeStr = dayjs(note.createTime).format('dddd MMM DD, h:mm A');

    return (
        <div className={s.note}>
            <div className={s.time}>{timeStr}</div>
            <div
                className={expanded ? s.contentExpanded : s.content}
                style={{
                    width: isOverflow ? '252px' : 'auto',
                }}
                ref={contentRef}
                title={note.notes}
            >
                {note.notes}
                {!expanded && isOverflow && (
                    <a className={s.link} onClick={() => setExpanded(true)}> View all</a>
                )}
            </div>
            <div
                className={s.hiddenContent}
                ref={hiddenRef}
                title={note.notes}
            >
                {note.notes}
            </div>
        </div>
    );
};

export default Note;
